<template>
  <div class="cap-bubble">
    <div class="cap-title">{{ intent.title || "(ยังไม่ได้ตั้งหัวข้อ)" }}</div>
    <p v-if="intent.answer" class="cap-text">
      <template v-for="(seg, i) in richText(intent.answer)">
        <strong v-if="seg.bold" :key="i">{{ seg.text }}</strong>
        <span v-else :key="i">{{ seg.text }}</span>
      </template>
    </p>
    <p v-else class="cap-text grey--text">(ยังไม่ได้พิมพ์คำตอบ)</p>

    <ol v-if="steps.length" class="cap-steps">
      <li v-for="(step, i) in steps" :key="i">
        <template v-for="(seg, j) in richText(step)">
          <strong v-if="seg.bold" :key="j">{{ seg.text }}</strong>
          <span v-else :key="j">{{ seg.text }}</span>
        </template>
      </li>
    </ol>

    <div v-if="intent.tip" class="cap-tip">
      <v-icon small color="amber darken-3" class="mr-1">mdi-lightbulb-on-outline</v-icon>{{ intent.tip }}
    </div>

    <div v-if="links.length" class="mt-2">
      <v-chip v-for="(link, i) in links" :key="i" small color="primary" class="mr-1 mb-1">
        <v-icon left x-small>mdi-arrow-right-circle</v-icon>{{ link.label }}
      </v-chip>
    </div>
  </div>
</template>

<script>
/**
 * ChatAnswerPreview.vue — แสดงคำตอบหน้าตาเดียวกับกล่องข้อความในแชท (HrvecChatbot.vue)
 * ใช้ในหน้าจัดการผู้ช่วย HRVEC ให้แอดมินเห็นผลก่อนบันทึก / ในแท็บทดสอบถาม-ตอบ
 */
export default {
  name: "ChatAnswerPreview",
  props: {
    intent: { type: Object, required: true },
    role: { type: String, default: "" }
  },
  computed: {
    steps() {
      return (this.intent.steps || []).filter(s => s && s.trim());
    },
    // role ว่าง = แสดงลิงก์ทั้งหมด (โหมดแก้ไข), มี role = แสดงเฉพาะที่กลุ่มนั้นเห็นจริง (โหมดทดสอบ)
    links() {
      return (this.intent.links || []).filter(
        l => l.label && (!this.role || !l.roles || !l.roles.length || l.roles.includes(this.role))
      );
    }
  },
  methods: {
    richText(text) {
      return String(text || "")
        .split(/\*\*(.+?)\*\*/g)
        .map((part, i) => ({ text: part, bold: i % 2 === 1 }))
        .filter(seg => seg.text);
    }
  }
};
</script>

<style scoped>
.cap-bubble {
  max-width: 420px;
  padding: 10px 14px;
  font-size: 0.9rem;
  line-height: 1.6;
  color: #263238;
  background: #fff;
  border: 1px solid #e3e8ef;
  border-radius: 16px 16px 16px 4px;
}
.cap-title {
  margin-bottom: 4px;
  font-weight: 600;
  color: #0d47a1;
}
.cap-text {
  margin: 0;
  white-space: pre-line;
}
.cap-steps {
  margin: 8px 0 0;
  padding-left: 20px;
}
.cap-tip {
  margin-top: 10px;
  padding: 8px 10px;
  font-size: 0.82rem;
  background: #fff8e1;
  border-radius: 8px;
}
</style>
